import React, { useState, useEffect, useRef, useCallback } from "react";
import $ from "jquery";
import Wrapper from "../../components/shared/Wrapper";
import liveDot from "../../assets/liveDot.png";
import { sendTestMatomoEvent } from "../../Analytics/MatomoManager/matomoTest";

const TvRadioRowList = ({
  borderRadius,
  rowWidth,
  rowHeight,
  columnWidth,
  columnHeight,
  itemWidth,
  itemHeight,
  animationSpeed,
  bgColor,
  shouldFocus,
  marginLeft,
  marginTop,
  borderColor,
  fontSize,
  fontColor,
  selectionStyle,
  data,
  border,
  FocusHandler,
  RowlListcallBack,
  handleBackButton,
  handleRowListDownButton,
  handleRowListUpButton,
  shouldUpFocus,
  isOnfocusDataLoad = false,
  gapBetweenColumn = 0,
  activeStyle,
  lastFocusedElementRowList,
  rememberFocusItem,
  rememberFocusItem1,
  lastRememberFocusedRowList,
  screen,
  page
}) => {
  const [selectedIndex, setSelectedIndex] = useState(rememberFocusItem || 0);
  const [activeItem, setActiveItem] = useState(rememberFocusItem || 0);
  const rowRef = useRef(null);

  const [state, setState] = useState({
    liveEventsData: null,
    OnfocusDataLoad: isOnfocusDataLoad,
  });

  // --- FIXED SCROLL LOGIC ---
  // Calculates exact position based on the specific DOM element
  const scrollToItem = (index) => {
    const container = rowRef.current;
    if (!container) return;

    const children = container.children;
    const targetElement = children[index];

    if (!targetElement) return;

    // 1. Get exact dimensions from the DOM
    const containerWidth = container.clientWidth;
    const itemLeft = targetElement.offsetLeft; // Distance from the start of the list
    const itemWidth = targetElement.offsetWidth; 
    const maxScroll = container.scrollWidth - containerWidth;

    // 2. Calculate Center Position
    // We want the center of the item to align with the center of the container
    let targetScrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2);

    // 3. Clamp values (Don't scroll past start or end)
    if (targetScrollLeft < 0) {
      targetScrollLeft = 0;
    } else if (targetScrollLeft > maxScroll) {
      targetScrollLeft = maxScroll;
    }

    // 4. Animate using jQuery on the ref directly
    $(container).stop().animate({ scrollLeft: targetScrollLeft }, 300);
  };

  function debounceMultiple(funcs, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        funcs.forEach((fn) => fn(...args));
      }, delay);
    };
  }

  // Restore focus on mount
  useEffect(() => {
    if (rememberFocusItem !== undefined && rememberFocusItem !== null) {
      // Small timeout to ensure DOM is rendered before scrolling
      setTimeout(() => {
        setSelectedIndex(rememberFocusItem);
        setActiveItem(rememberFocusItem);
        scrollToItem(rememberFocusItem);
      }, 100);
    }
  }, [rememberFocusItem]);

  const handleKeyDown = (e) => {
    const rowLength = data.length;

    if (e.keyCode === 39) { // Right
      if (selectedIndex < rowLength - 1) {
        const newIndex = selectedIndex + 1;
        setSelectedIndex(newIndex);
        scrollToItem(newIndex);
      }
    } else if (e.keyCode === 37) { // Left
      if (selectedIndex > 0) {
        const newIndex = selectedIndex - 1;
        setSelectedIndex(newIndex);
        scrollToItem(newIndex);
      } else {
        rowRef.current.removeEventListener("keyDown", handleKeyDown);
        rowRef.current.blur();
        handleBackButton();
      }
    } else if (e.keyCode === 13) { // Enter
      console.log("Enter key pressed on index:", selectedIndex);
      setActiveItem(selectedIndex);
      scrollToItem(selectedIndex); // Ensure visibility on selection

      if (data[selectedIndex].isLive == 1) {
        // If live logic needed
      } else {
        RowlListcallBack(data[selectedIndex], selectedIndex);
        
        // Analytics
        if (page === "home") {
          sendTestMatomoEvent({
            eventCategory: "TagMenu",
            eventAction: "Select",
            eventName: `Tag(${data[selectedIndex].id}/${data[selectedIndex].title})`,
            url: page,
          });
        } else if (page === "tv-radio") {
          sendTestMatomoEvent({
            eventCategory: "Live",
            eventAction: "Select",
            eventName: `Live - Select - ${data[selectedIndex].title}`,
            url: page,
          });
        }
      }
    } else if (e.keyCode === 8 || e.keyCode === 10009 || e.keyCode === 461) { // Back
      window.removeEventListener("keyDown", handleKeyDown);
      rowRef.current.removeEventListener("keyDown", handleKeyDown);
      rowRef.current.blur();
      handleBackButton();
    } else if (e.keyCode === 40) { // Down
      const currentId = data[selectedIndex]?.id;
      const excluded = ["aboutus", "privacypolicy", "termsandcondition", "helpandsupport", "subscriptionrental", "myaccount", "referalcode"];

      if (!excluded.includes(currentId)) {
        if (currentId === "applanguage") {
          if (activeItem === selectedIndex) {
            rowRef.current.removeEventListener("keyDown", handleKeyDown);
            rowRef.current.blur();
            handleRowListDownButton();
          }
        } else {
          rowRef.current.removeEventListener("keyDown", handleKeyDown);
          rowRef.current.blur();
          handleRowListDownButton();
        }
      }
    } else if (e.keyCode === 38) { // Up
      handleRowListUpButton ? handleRowListUpButton() : handleBackButton();
    }
  };

  useEffect(() => {
    if (shouldFocus) {
      let tmr = setTimeout(function () {
        clearTimeout(tmr);
        rowRef?.current?.focus();
      }, 200);
    }
  }, [shouldFocus, state.OnfocusDataLoad]);

  useEffect(() => {
    if (screen === "LiveScreen") {
      if (lastRememberFocusedRowList === "Radio") {
        setSelectedIndex(1);
        setActiveItem(1);
      } else {
        setSelectedIndex(0);
        setActiveItem(0);
      }
    }
  }, [lastRememberFocusedRowList, screen]);

  const debouncedKeyDown = useCallback(
    debounceMultiple([handleKeyDown], 10),
    [handleKeyDown, selectedIndex]
  );

  return (
    <div
      ref={rowRef}
      style={{
        width: rowWidth,
        height: rowHeight,
        backgroundColor: bgColor,
        marginLeft: marginLeft,
        marginTop: marginTop,
        overflow: "hidden", 
        whiteSpace: "nowrap",
        outline: "none",
        display: "flex",
        alignItems: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        // Removed scrollBehavior: "smooth" to let jQuery handle animation accurately
      }}
      tabIndex="0"
      onKeyDown={debouncedKeyDown}
      id="grid-row"
    >
      {data.map((item, index) => (
        <div
          key={item.id}
          style={{
            alignItems: "center",
            marginRight: gapBetweenColumn + "px",
            display: "inline-block" // Essential for horizontal calculation
          }}
        >
          <Wrapper
            style={{
              flexDirection: "column",
              width: "fit-content",
              padding: "10px 60px",
              lineHeight: `${itemHeight}px`,
              textAlign: "center",
              justifyContent: "center",
              backgroundColor:
                selectionStyle === "background" && selectedIndex === index && shouldFocus
                  ? borderColor
                  : "transparent",
              border: activeStyle === "border" && activeItem === index ? "3px solid #fff" : "none",
              position: "relative",
              boxSizing: "border-box",
              cursor: "pointer",
              borderRadius: borderRadius,
              fontSize: fontSize,
              color: fontColor,
              marginLeft: "10px",
            }}
            onMouseEnter={() => {
              setSelectedIndex(index);
            }}
            onClick={() => {
              setActiveItem(index);
              setSelectedIndex(index);
              scrollToItem(index); // Scroll to clicked item immediately
              
              if (item.isLive == 1) {
                 // Logic for live items
              } else {
                 RowlListcallBack(item, index);
              }
            }}
          >
            {item.title === "Live" && (
              <img
                src={liveDot}
                style={{ width: "12px", height: "12px", marginRight: "5px", verticalAlign: "middle" }}
                alt="Live"
              />
            )}
            {item.title}

            {index === activeItem && activeStyle === "underline" && !(shouldFocus && selectedIndex === index) && (
              <span
                style={{
                  content: "''",
                  position: "absolute",
                  bottom: "-10px",
                  left: "50%",
                  width: "50%",
                  height: "8px",
                  backgroundColor: "#EC008C",
                  transform: "translateX(-50%)",
                }}
              />
            )}
             {index === activeItem && activeItem !== selectedIndex && activeStyle === "underline" && screen === "SettingsScreen" && (
                <span
                  style={{
                    content: "''",
                    position: "absolute",
                    bottom: "-10px",
                    left: "50%",
                    width: "50%", 
                    height: "8px", 
                    backgroundColor: "#EC008C", 
                    transform: "translateX(-50%)", 
                  }}
                />
            )}
          </Wrapper>
        </div>
      ))}
    </div>
  );
};

export default TvRadioRowList;